import { Space as AntdSpace, type SpaceProps as AntdSpaceProps } from 'antd'
import { clsx } from 'clsx'
import styles from './styles.module.scss'

// SIZES
// Small -> 8px (.5rem)
// Middle -> 16px (1rem)
// Large -> 24px (1.5rem)
export interface SpaceProps extends AntdSpaceProps {
  children: React.ReactNode
  direction?: 'horizontal' | 'vertical'
  size?: AntdSpaceProps['size']
  wrap?: boolean
}

export function Space({
  children,
  size = 'small',
  direction = 'horizontal',
  wrap,
  ...props
}: SpaceProps) {
  return (
    <AntdSpace
      {...props}
      className={clsx(styles.space, { [styles.wrap]: wrap }, props.className)}
      direction={direction}
      size={size}
    >
      {children}
    </AntdSpace>
  )
}
